<template>
	<div class="main">
		<Table
			:columns="columns"
			row-key="id"
			:request="request"
			:searchData ="searchData"
			:formData="formData"
			:mulselect="false"
			ref="tableref"
		>
		<!-- 查询form -->
		<template v-slot:formItem>
			<a-form-model-item>
				<a-input v-model="searchData.name" allowClear placeholder="姓名" />
			</a-form-model-item>
			<a-form-model-item>
				<a-input v-model="searchData.idcard" allowClear placeholder="身份证号" />
			</a-form-model-item>
			<a-form-model-item >
                <a-select placeholder="材料类型" v-model="searchData.cltype" style="width:400px" allowClear>
					<a-select-option v-for="item in cltypeArray" :key="item.id" :value="item.id+''">{{item.name}}</a-select-option>
				</a-select>
            </a-form-model-item>
			<a-form-model-item>
				<a-select v-model="searchData.workplace" allowClear placeholder="所属工地" style="width:180px">
					<a-select-option v-for="item in workplaceArray" :key="item.id" :value="item.id"  >{{item.name}}</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item>
				<a-date-picker v-model="searchData.starttime" style="min-width:120px" allowClear placeholder="开始时间" ></a-date-picker>
			</a-form-model-item>
			<a-form-model-item>
				<a-date-picker v-model="searchData.endtime" style="min-width:120px" allowClear placeholder="结束时间" ></a-date-picker>
			</a-form-model-item>
		</template>

		<!-- 保存数据的form -->
		<template v-slot:itemFormData>
			<a-form-model-item label="开始时间">
                <a-date-picker placeholder="请输入开始时间" v-model="formData.starttime"></a-date-picker>
            </a-form-model-item>
			<a-form-model-item label="结束时间">
                <a-date-picker placeholder="请输入结束时间" v-model="formData.endtime"></a-date-picker>
            </a-form-model-item>
			<a-form-model-item label="身份证号码">
                <a-input placeholder="请输入身份证号码" v-model="formData.idcard" ></a-input>
            </a-form-model-item>
			<a-form-model-item label="所属工地">
                <a-select placeholder="所属工地" v-model="formData.workplace" @change="getfromcailiaodan">
					<a-select-option v-for="item in workplaceArray" :key="item.id" :text="item.name" :value="item.id+''">{{item.name}}</a-select-option>
				</a-select>
            </a-form-model-item>
			<a-form-model-item label="姓名">
                <a-input placeholder="请输入姓名" v-model="formData.name"></a-input>
            </a-form-model-item>

			<a-form-model-item label="材料">
				<a-upload 
				 name="file"
				 :multiple="true"
				 :showUploadList="false"
				 accept="xlsx"
				 :beforeUpload="filehandle"
				>
					<a-button>上传excle</a-button>
				</a-upload>
				<a-button @click="exportall">导出所有</a-button>
				<div>
					<div v-for="excel in formData.excels" :key="excel.uid" class="filelist">
						<span>
							{{excel.name}}
						</span>
						<span>
							总价:{{excel.sum}}
						</span>
						<downloadexcel
							class="ant-btn export-btn"
							:data="excel.data"
							:fields="excelheader"
							:name="excel.name"
	     				 >导出</downloadexcel>
						<a-button @click="delexcel(excel.uid)">删除</a-button>
					</div>
				</div>
			</a-form-model-item>
			<a-form-model-item label="材料">
				<div v-for="(clitem,id) in formData.clinfo"  :key="clitem.key" style="display:flex">
					<a-form-model-item >
						<a-select style="min-width:120px" placeholder="材料类型" v-model="clitem.type">
							<a-select-option v-for="item in cltypeArray" :key="item.id" :value="item.id+''">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
					<a-form-model-item>
						<a-input-number placeholder="单价" v-model="clitem.price"></a-input-number>
					</a-form-model-item>
					<a-form-model-item >
						<a-input-number placeholder="数量" v-model="clitem.num"></a-input-number>
					</a-form-model-item>
					<a-form-model-item >
						<a-input-number placeholder="总价" v-model="clitem.sum" @focus="getsum(clitem,id)"></a-input-number>
					</a-form-model-item>
					<a-form-model-item >
						<a-button @click="delclinfo(clitem.key)">删除</a-button>
					</a-form-model-item>
				</div>
				<a-button @click="addclinfo">添加</a-button>
			</a-form-model-item>
			<a-form-model-item label="应付金额">
                <a-input placeholder="请输入应付金额" v-model="formData.yingfu" @focus="getyingfu"></a-input>
            </a-form-model-item>
			<a-form-model-item label="材料单预支金额">
                <a-input placeholder="请输入材料单预支金额" v-model="formData.clyuzhi" ></a-input>
            </a-form-model-item>
			<a-form-model-item label="项目发放金额">
                <a-input placeholder="请输入项目发放金额" v-model="formData.fafang" ></a-input>
            </a-form-model-item>
			<a-form-model-item label="是否发放">
                <a-select placeholder="请选择发放状态" v-model="formData.shifoufafang" @change="changejieyu">
				<a-select-option value="0">未发放</a-select-option>
				<a-select-option value="1">已发放</a-select-option>
				</a-select>
            </a-form-model-item>
			<a-form-model-item label="结余金额">
                <a-input placeholder="请输入结余金额" v-model="formData.jieyu"></a-input>
            </a-form-model-item>
		</template>

		<!-- 表格数据转化插槽 -->
		<template v-slot:workplace="{text}">
			{{workplaceshow(text)}}
        </template>
		<template v-slot:shifoufafang="{text}">
			{{text==1?"已发放":"未发放"}}
        </template>

		<!--添加按钮预留位置  -->
		<template v-slot:addAction="{showModal}">
			<a-form-model-item>
				<a-button type="primary" @click="addcld(showModal)"> <a-icon type="plus"/> 添加</a-button>
			</a-form-model-item>
		</template>

		<!-- 行末操作按钮插槽 -->
		<template v-slot:tableAction="{record,showModal,showDelConfirm}">
           <a class="tAction" @click="updatecldan(record,showModal)"><a-icon type="edit" />修 改</a>
           <a-divider type="vertical" />
           <a class="tAction" @click="deletecldan(record,showDelConfirm)"><a-icon type="delete" /> 删 除</a>
        </template>
		</Table>
	</div>
</template>

<script>
import Cailiaozhangdan  from "./index.js"
export default Cailiaozhangdan
</script>
<style scoped>
.export-btn{
	    line-height: 30px ;
    }
.filelist{
	display: flex;
	justify-content:space-around;
}
</style>


